﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import {
    IndividualIdentifierTypes,
    OrganizationIdentifierTypes,
} from "~base/Internationalization/ConfigurationInfo";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export function getSubjectType(
    conIdentifier: string
): IndividualIdentifierTypes | OrganizationIdentifierTypes {
    switch (conIdentifier) {
        case "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPerson.Personnummer.SWE":
            return "PersonnummerSE";
        case "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPerson.Epost":
            return "Email";
        case "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.JuridiskPerson.Organisationsnummer.SWE":
            return "OrganisationsnummerSE";
        case "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.JuridiskPerson.Organisationsnummer.NL":
            return "OrganisationsnummerNL";
        case "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPerson.ExterntRegisterId":
            return "ExterntRegisterId";
        case "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPersonPar.ExterntRegisterId":
            return "ParExterntRegisterId";
        case "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPersonPar.Personnummer.SWE":
            return "ParPersonnummerSE";
        default:
            return null;
    }
}

export function getSubjectIdentifierConType(
    subjectType: IndividualIdentifierTypes | OrganizationIdentifierTypes
): string {
    switch (subjectType) {
        case "PersonnummerSE":
            return "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPerson.Personnummer.SWE";
        case "Email":
            return "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPerson.Epost";
        case "OrganisationsnummerSE":
            return "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.JuridiskPerson.Organisationsnummer.SWE";
        case "OrganisationsnummerNL":
            return "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.JuridiskPerson.Organisationsnummer.NL";
        case "ExterntRegisterId":
            return "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPerson.ExterntRegisterId";
        case "ParExterntRegisterId":
            return "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPersonPar.ExterntRegisterId";
        case "ParPersonnummerSE":
            return "VisiFinance.Consilio.Rådgivningssubjekt.Identifierare.FysiskPersonPar.Personnummer.SWE";
        default:
            return null;
    }
}
